import Pagination, { PaginationProps } from "antd/es/pagination"
import React, { createElement } from "react"
import ArrowLeftOutlined from "@ant-design/icons/lib/icons/ArrowLeftOutlined"
import ArrowRightOutlined from "@ant-design/icons/lib/icons/ArrowRightOutlined"
import { Link, navigate } from "gatsby"

const renderPaginationItem = (lastPage: number): PaginationProps["itemRender"] => (
  page,
  type,
  originalElement,
) => {
  const pageUrl = page === 1 ? "/" : `/${page}`;

  switch (type) {
    case "prev":
      return (
        <Link to={pageUrl}>
          <ArrowLeftOutlined />
        </Link>
      )
    case "next":
      return (
        <Link to={pageUrl}>
          <ArrowRightOutlined />
        </Link>
      )
    case "page":
      return <Link to={pageUrl}>{page}</Link>
    case "jump-next":
    case "jump-prev":
      return <Link to={pageUrl}>{originalElement.props.children}</Link>
    default:
      return originalElement;
  }
}
type Props = {
  currentPage: number
  numPages: number
}
export const ListPagination: React.FC<Props> = ({ currentPage, numPages }) => {
  const shouldShowPagination = numPages > 1

  const handleOnChange: PaginationProps["onChange"] = page => {
    navigate(page === 1 ? "/" : `/${page}`)
  }

  return shouldShowPagination ? (
    <Pagination
      current={currentPage}
      total={numPages}
      pageSize={1}
      itemRender={renderPaginationItem(numPages)}
      showSizeChanger={false}
      onChange={handleOnChange}
      style={{ display: "flex", justifyContent: "center", width: "100%" }}
    />
  ) : null
}
